module.exports = __webpack_public_path__ + "static/media/defaultPostThumbnail.75203fec.png";